<template>
  <TransitionGroup name="notif-banner" tag="div" class="notif-banner-stack" aria-live="polite">
    <article
      v-for="item in items"
      :key="item.notification_id"
      class="notif-banner"
      :style="{ '--accent': meta(item).color }"
      role="button"
      tabindex="0"
      @click="$emit('open', item)"
      @keydown.enter.prevent="$emit('open', item)"
      @mouseenter="$emit('hold', item.notification_id)"
      @mouseleave="$emit('release', item.notification_id)"
    >
      <div class="notif-banner__icon">
        <q-icon :name="meta(item).icon" size="20px" />
      </div>
      <div class="notif-banner__content">
        <div class="notif-banner__meta">{{ meta(item).label }} · только что</div>
        <div class="notif-banner__title">{{ item.title }}</div>
        <div v-if="item.body" class="notif-banner__body">{{ item.body }}</div>
      </div>
      <q-btn
        flat
        round
        dense
        size="sm"
        icon="close"
        color="grey-7"
        class="notif-banner__close"
        aria-label="Закрыть"
        @click.stop="$emit('dismiss', item)"
      />
    </article>
  </TransitionGroup>
</template>

<script>
import { getModuleMeta } from "./constants";

export default {
  name: "NotificationBannerStack",
  props: {
    items: { type: Array, default: () => [] },
  },
  emits: ["dismiss", "open", "hold", "release"],
  methods: {
    meta(item) {
      return getModuleMeta(item.source_module);
    },
  },
};
</script>

<style scoped lang="scss">
// Справа под шапкой, чтобы не закрывать её.
.notif-banner-stack {
  position: fixed;
  top: 76px;
  right: 16px;
  z-index: 9000;
  width: min(380px, calc(100vw - 32px));
  display: flex;
  flex-direction: column;
  gap: 8px;
  pointer-events: none;

  > * {
    pointer-events: auto;
  }
}

.notif-banner {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 12px 8px 12px 14px;
  border-radius: 12px;
  border: 1px solid #e5e7eb;
  border-left: 4px solid var(--accent);
  background: #fff;
  box-shadow: 0 12px 32px rgba(17, 24, 39, 0.14);
  cursor: pointer;
  outline: none;

  &:hover,
  &:focus-visible {
    box-shadow: 0 14px 36px rgba(17, 24, 39, 0.2);
  }

  &__icon {
    flex-shrink: 0;
    width: 36px;
    height: 36px;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: var(--accent);
    background: #f2f5f8;
    background: color-mix(in srgb, var(--accent) 10%, #fff);
  }

  &__content {
    flex: 1;
    min-width: 0;
  }

  &__meta {
    font-size: 12px;
    line-height: 16px;
    font-weight: 600;
    color: #6b7280;
    margin-bottom: 2px;
  }

  &__title {
    font-size: 14px;
    line-height: 20px;
    font-weight: 700;
    color: #111827;
  }

  &__body {
    margin-top: 2px;
    font-size: 13px;
    line-height: 18px;
    color: #4b5563;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }

  &__close {
    flex-shrink: 0;
    margin-top: -2px;
  }
}

.notif-banner-enter-active,
.notif-banner-leave-active {
  transition: opacity 0.25s ease, transform 0.25s ease;
}

.notif-banner-enter-from,
.notif-banner-leave-to {
  opacity: 0;
  transform: translateX(24px);
}

.notif-banner-move {
  transition: transform 0.25s ease;
}

@media (max-width: 576px) {
  .notif-banner-stack {
    top: 64px;
    right: 12px;
    width: calc(100vw - 24px);
  }
}

@media (prefers-reduced-motion: reduce) {
  .notif-banner-enter-active,
  .notif-banner-leave-active,
  .notif-banner-move {
    transition: none;
  }
}
</style>
